import { render, staticRenderFns } from "./ContainerAccountDetail.pug?vue&type=template&id=5255efba&lang=pug&"
import script from "./ContainerAccountDetail.vue?vue&type=script&lang=js&"
export * from "./ContainerAccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports